import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandshake = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3192_33122)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.55347 14.0843L7.28447 14.8153C7.83588 15.3667 8.72348 15.3667 9.2749 14.8153C9.82631 14.2639 9.82631 13.3763 9.2749 12.8249L8.20389 11.7539L7.72307 12.2347L8.79407 13.3057C9.07906 13.5907 9.07906 14.0495 8.79407 14.3345C8.50908 14.6195 8.05028 14.6195 7.7653 14.3345L7.03429 13.6035L6.55347 14.0843Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.62457 3.28134L5.69534 3.25594L4.02941 1.59375L-0.00415039 5.62731L1.65988 7.29133V9.0851H2.33988V7.00968L0.957506 5.62731L4.02995 2.55486L5.41042 3.93227L7.61559 3.96127L7.62457 3.28134Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.0545 3.59281L13.0536 1.59375L11.3897 3.25768H7.47966L5.39447 5.34286C4.85353 5.8838 4.85353 6.75835 5.39447 7.29929C5.93541 7.84023 6.80996 7.84023 7.3509 7.29929L8.39317 6.25702L10.7091 6.26613L14.6017 10.1587C14.8767 10.4338 14.8767 10.8784 14.6017 11.1535C14.3266 11.4285 13.882 11.4285 13.6069 11.1535L11.2303 8.77686L10.7495 9.25769L13.1261 11.6343C13.667 12.1752 14.5416 12.1752 15.0825 11.6343C15.6234 11.0934 15.6234 10.2188 15.0825 9.67786L15.0271 9.62248L15.4235 9.22611V7.28811L17.0877 5.62397L15.0545 3.59281L14.5737 4.07364L16.1257 5.62418L14.7435 7.00645V8.94445L14.5463 9.14165L10.9919 5.58722L8.11261 5.57593L6.87007 6.81846C6.59501 7.09352 6.15036 7.09352 5.8753 6.81846C5.60024 6.5434 5.60024 6.09875 5.8753 5.82369L7.76132 3.93768H11.6713L13.0538 2.5552L14.5737 4.07364L15.0545 3.59281Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.7365 9.24645L13.3001 11.8101C13.5854 12.0953 13.5854 12.5569 13.3001 12.8422C13.0151 13.1272 12.5541 13.1275 12.2687 12.843C12.2682 12.8426 9.72565 10.2796 9.72565 10.2796L9.24292 10.7585L11.7866 13.3226C12.3382 13.8742 13.2298 13.8742 13.7809 13.3231C14.332 12.7719 14.332 11.8803 13.7809 11.3292L11.2173 8.76562L10.7365 9.24645Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9.2414 10.7707L11.1019 12.6551C11.3845 12.9377 11.3845 13.3926 11.1027 13.6744C10.8209 13.9562 10.3659 13.9562 10.0842 13.6744L8.20055 11.7908L7.71973 12.2717L9.60333 14.1553C10.1511 14.7031 11.0357 14.7031 11.5836 14.1553C12.131 13.6078 12.1314 12.7239 11.5846 12.1761L9.72528 10.293L9.2414 10.7707Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M1.27929 11.3778L1.27976 11.3782C1.83468 11.9287 2.73337 11.9277 3.28332 11.3778L4.53792 10.1232C5.09259 9.56848 5.09259 8.67381 4.53792 8.11913C3.98324 7.56446 3.08856 7.56446 2.53389 8.11913L1.27929 9.37373C0.724612 9.92841 0.724612 10.8231 1.27929 11.3778ZM1.75964 10.8965C1.47159 10.6079 1.47176 10.1429 1.76012 9.85456L3.01472 8.59996C3.30324 8.31144 3.76856 8.31144 4.05709 8.59996C4.34561 8.88848 4.34561 9.35381 4.05709 9.64233L2.80249 10.8969C2.51631 11.1831 2.04884 11.1824 1.76001 10.8968L1.75964 10.8965Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M3.10961 12.731C3.66429 13.2856 4.55896 13.2856 5.11364 12.731L5.59644 12.2482C6.15111 11.6935 6.15111 10.7988 5.59644 10.2441C5.04176 9.68946 4.14709 9.68946 3.59241 10.2441L3.10961 10.7269C2.55493 11.2816 2.55493 12.1763 3.10961 12.731ZM3.59044 12.2501C3.30191 11.9616 3.30191 11.4963 3.59044 11.2078L4.07324 10.725C4.36176 10.4364 4.82709 10.4364 5.11561 10.725C5.40413 11.0135 5.40413 11.4788 5.11561 11.7673L4.63281 12.2501C4.34429 12.5387 3.87896 12.5387 3.59044 12.2501Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4.87306 14.0252C5.42359 14.5797 6.32279 14.5805 6.87756 14.0257L6.92856 13.9747C7.48324 13.42 7.48324 12.5254 6.92856 11.9707C6.37389 11.416 5.47921 11.416 4.92453 11.9707L4.87353 12.0217C4.31899 12.5762 4.31886 13.4705 4.87306 14.0252ZM5.35535 13.5459L5.35484 13.5454C5.06584 13.2564 5.06584 12.791 5.35436 12.5025L5.40536 12.4515C5.69389 12.163 6.15921 12.163 6.44774 12.4515C6.73626 12.74 6.73626 13.2054 6.44774 13.4939L6.39674 13.5449C6.10848 13.8331 5.64126 13.8341 5.35535 13.5459Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3192_33122",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17,
				height: 17
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHandshake);
export default ForwardRef;
